const e = "style-module__countryLanguageSelector___LXBfq", _ = "style-module__clickableWrapper___yKgwb", t = "style-module__language___0R71d", l = "style-module__icon___2MDNZ", a = "style-module__selectorWrapper___hhMN4", o = "style-module__selector___FNIjx", c = "style-module__languages___RSPjY", n = "style-module__languageName___XLPPM", s = "style-module__active___Pkbho", r = "style-module__bottomGradient___HVtRb", u = {
  countryLanguageSelector: e,
  clickableWrapper: _,
  language: t,
  icon: l,
  selectorWrapper: a,
  selector: o,
  languages: c,
  languageName: n,
  active: s,
  bottomGradient: r
};
export {
  s as active,
  r as bottomGradient,
  _ as clickableWrapper,
  e as countryLanguageSelector,
  u as default,
  l as icon,
  t as language,
  n as languageName,
  c as languages,
  o as selector,
  a as selectorWrapper
};
